import { useLanguage } from '../contexts/LanguageContext';
import translations from '../shared/constants/translations';
import { LANGUAGES } from '../shared/constants';

/**
 * Custom hook for handling translations
 * Provides easy access to translations and translation utilities
 */
export const useTranslation = () => {
  const { language, toggleLanguage, isArabic, isEnglish, direction } = useLanguage();
  
  // Get current language translations
  const t = translations[language] || translations[LANGUAGES.ARABIC];
  
  // Translation helper function with fallback
  const translate = (key, fallback = '') => {
    const keys = key.split('.');
    let value = t;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return fallback || key;
      }
    }
    
    return value || fallback || key;
  };
  
  // Check if translation exists
  const hasTranslation = (key) => {
    const keys = key.split('.');
    let value = t;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return false;
      }
    }
    
    return typeof value === 'string' && value.length > 0;
  };
  
  // Format text with parameters
  const formatText = (key, params = {}) => {
    let text = translate(key);
    
    if (typeof text === 'string' && params) {
      Object.keys(params).forEach(param => {
        const placeholder = `{{${param}}}`;
        text = text.replace(new RegExp(placeholder, 'g'), params[param]);
      });
    }
    
    return text;
  };
  
  return {
    t,
    translate,
    hasTranslation,
    formatText,
    language,
    toggleLanguage,
    isArabic,
    isEnglish,
    direction,
    currentLanguage: language
  };
};

export default useTranslation;